// AUTO-GENERATED FILE - DO NOT EDIT
import * as z from "zod";
import { requestHandler } from "../requestHandler";

export const path = "search-for-load";

const stateSchema = z.enum([
  "Not Assigned",
  "Assigned",
  "Being Picked Up",
  "In Transit",
  "Delivered",
  "Cancelled",
]);

export const LoadSchema = z
  .object({
    loadId: z.string(),
    trailerNumber: z.string(),
    loadState: z.string(),
    sourceStationName: z.string(),
    destinationStationName: z.string(),
    name: z.string(),
  })
  .strict();

export const searchForLoadResponseSchema = z.array(LoadSchema);

export const searchForLoadParamsSchema = z
  .object({
    searchQuery: z.string(),
  })
  .strict();




export type Load = z.infer<typeof LoadSchema>;

export type SearchForLoadResponse = z.infer<typeof searchForLoadResponseSchema>;

export type SearchForLoadParams = z.infer<typeof searchForLoadParamsSchema>;




// receiver/search-for-load endpoint
export function searchForLoad(
  params: z.input<typeof searchForLoadParamsSchema>
): Promise<SearchForLoadResponse> {
  return requestHandler(
    "receiver/search-for-load",
    params,
    searchForLoadResponseSchema,
  );
}

